














































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Popup } from '@questelservices/common-vue';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DataGrid } from '@questelservices/common-vue';
import { DxEditing, DxColumn, DxHeaderFilter, DxStateStoring, DxScrolling,DxDataGrid, DxFilterRow } from 'devextreme-vue/data-grid';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxButton } from 'devextreme-vue';
import DevExpress from 'devextreme/bundles/dx.all';
import { CommentService } from '../../service/CommentService';
import { PhaseTypeDto } from '@/models/PhaseTypeDto';
import { InfractionTypeDto } from '@/models/infractions/InfractionTypeDto';
import { PhaseTypeService } from '@/service/PhaseTypeService';
import { InfractionService } from '@/service/InfractionService';
import {FileLookupService} from '@/service/FileLookupService';
import RespondToComment from '@/components/activity-planner/respond-to-comment.vue'
import {RespondEnum} from '@/models/comments/RespondEnum';
import DateTime from '../../utilities/DateTime';
import MatterDetails from '@/components/matter/matter-details.vue';
import { FileService } from '@/service/FileService';
import FileSaver, { saveAs } from 'file-saver';
import CustomStore from 'devextreme/data/custom_store';

// const chromedriver = require('chromedriver');
@Component({
        components: {
            DxDataGrid,
            DxButton,
            DxColumn,
            DxScrollView,
            DxHeaderFilter,
            DxFilterRow,
            DxScrolling
        }
    })
    export default class FileServiceGrid extends Vue {
        dataGridCustomStoreOption: CustomStore;
        private fileLookupService: FileLookupService;
        private fileService: FileService;
        constructor() {
            super();
            this.fileLookupService = new FileLookupService();
            this.fileService = new FileService();
             this.dataGridCustomStoreOption  = new CustomStore({         
                    load: (options): Promise<any> => {
                    return this.fileLookupService.searchFiles(options)
                        .catch(result => {
                            throw 'An error occurred loading the agent setup.';
                        });
                    }            
                });
             // = {
            //     key: 'Id',
            //     load: loadOptions => this.fileLookupService.searchFiles(loadOptions)                
            // };
        }

        SortingEmails(rowData: any) {
            return rowData.EmailTo + rowData.EmailCc;
        }

        onDownload(data:any) {
            if(data.FileId) {
                this.fileService.downloadFiles([data.FileId])
                .then(result => {
                    let fileName = result.headers.get('Filename');
                    result.blob().then((b: any) => {
                        // var childProcess = require('child_process');
                        // // var chromedriver = require('chromedriver');
                        // var binPath = chromedriver.path;
                        // var childArgs: any[] = [
                        
                        // ];
                        // childProcess.execFile(binPath, childArgs, function(err:any, stdout:any, stderr:any) {
                        //     var a = 1;
                        // // handle results
                        // });
                        // var returnPromise = true;
                        // var args: any[] = [
                        //     'safebrowsing.enabled=False'
                        // ];

                        // chromedriver.start(args, true);
                        // var a = 1;
                        // chromedriver.stop();
                        FileSaver.saveAs(b, decodeURIComponent(fileName));
                        // const url = window.URL.createObjectURL(b);
                        // const link = document.createElement('a');
                        // link.href = url;
                        // link.setAttribute('download', decodeURIComponent(fileName));
                        // document.body.appendChild(link);
                        // link.click();
                        // link.remove();
                    });
                })
            }
        }
        
    }
